// extracted by mini-css-extract-plugin
export default {"container":"legalNoticePage-module--container--8gnJF","header":"legalNoticePage-module--header--uYy9N","content":"legalNoticePage-module--content--o0297"};